export const LOGIN = 'login';
export const LOGOUT = 'logout';
export const USER = 'user';



// WEBPACK FOOTER //
// ./src/store/types.js